import { type Context, createContext } from 'react';

import DefaultInteractionID, { type InteractionIDContextType } from './defaultInteractionId';

export { default as DefaultInteractionID } from './defaultInteractionId';
export type { InteractionIDContextType } from './defaultInteractionId';

// We use a context to allow modals to have their own lifecycle
const interactionContext: Context<InteractionIDContextType> =
	createContext<InteractionIDContextType>(DefaultInteractionID);

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export default interactionContext;
export { subscribeToInteractionIdChanges } from './subscribeToInteractionIdChanges';
export { getInteractionId } from './getInteractionId';
export { useInteractionId } from './useInteractionId';
